const meta = {
  'query-syntax': 'Query syntax',
};

export default meta;
